import * as $ from "jquery";
import "select2";
import TranslationsService from '../services/translationsService';

// Init translations
const translationsService = TranslationsService.getInstance();
translationsService.addTranslations('translations');

/**
 * Finish options
 */
let finishData: any = {
	'polished-chrome': {
		name: translationsService.translate('FormValues.PolishedChromeFinishes'),
		options: [
			{
				name: translationsService.translate('FormValues.MidnightChrome'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-midnight-chrome?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.PolishedChrome'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-polished-chrome?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.PolishedBrass'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-polished-brass?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.PolishedNickel'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-polished-nickel?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.PolishedChromePolishedBlack'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-polished-chrome-polished-black?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.PolishedChromePolishedBrass'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-polished-chrome-polished-brass?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.PolishedChromeWhite'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-polished-chrome-white?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.PolishedChromeWhitePorcelain'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-polished-chrome-white-porcelain?pfFinishSwatch$&fmt=png-alpha'
			}
		]
	},
	'brushed': {
		name: translationsService.translate('FormValues.BrushedFinishes'),
		options: [
			{
				name: translationsService.translate('FormValues.BrushedBrass'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-brushed-brass?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.BrushedNickel'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-brushed-nickel?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.BrushedNickelPolishedBrass'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-brushed-nickel-polished-brass?pfFinishSwatch$&fmt=png-alpha '
			},
			{
				name: translationsService.translate('FormValues.BrushedNickelPolishedChrome'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-brushed-nickel-polished-chrome?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.BrushedStainlessSteel'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-brushed-stainless-steel?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.StainlessSteel'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-stainless-steel?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.StainlessSteelBlack'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-stainless-steel-black?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.Slate'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-slate?pfFinishSwatch$&fmt=png-alpha'
			}
		]
	},
	'bronze': {
		name: translationsService.translate('FormValues.BronzeFinishes'),
		options: [
			{
				name: translationsService.translate('FormValues.OilRubbedBronze'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-oil-rubbed-bronze?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.RusticBronze'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-rustic-bronze?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.TuscanBronze'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-tuscan-bronze?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.VelvetAgedBronze'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-velvet-aged-bronze?pfFinishSwatch$&fmt=png-alpha'
			}
		]
	},
	'copper': {
		name: translationsService.translate('FormValues.CopperFinishes'),
		options: [
			{
				name: translationsService.translate('FormValues.AntiqueCopper'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-antique-copper?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.FiredCopper'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-fired-copper?pfFinishSwatch$&fmt=png-alpha'
			}
		]
	},
	'other': {
		name: translationsService.translate('FormValues.Other'),
		options: [
			{
				name: translationsService.translate('FormValues.Biscuit'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-biscuit?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.Black'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-black?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.RusticPewter'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-rustic-pewter?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.UnpolishedChrome'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-unpolished-chrome?pfFinishSwatch$&fmt=png-alpha'
			},
			{
				name: translationsService.translate('FormValues.White'),
				image: '//images.pfisterfaucets.com/is/image/Pfister/finish-white?pfFinishSwatch$&fmt=png-alpha'
			}
		]
	}
};

function renderFinishFamilyOptions(options) {

	let optionResult = '';

	for (let i of options) {
		optionResult += `
			<li class="finish-family-result__item">
				<img class="finish-family-result__item-img" src="${i.image}">
				<span class="finish-family-result__item-name">${i.name}</span>
			</li>`;
	}

	return optionResult;
}

function initFinishSelectors() {
	$('.finish-selector').select2({
		placeholder: 'Select a Finish',
		minimumResultsForSearch: -1, // hide the search box
		templateResult: function (item) {
			if (!item.element) return;

			let family: string = $(item.element).data('finish-family');
			let familyData: any = finishData[family];

			let resultHTML = `
				<div class="finish-family-result">
					<div class="finish-family-result__title">${familyData.name}</div>
					<ul class="finish-family-result__list">
						${renderFinishFamilyOptions(familyData.options)}
					</ul>
				</div>`;

			return $(resultHTML);
		}
	});
}

export function init() {
	initFinishSelectors();
}



// WEBPACK FOOTER //
// ./js/PFF/modules/finishSelector.ts